export enum TimelineLabelType {
  MONTH = 'month',
  TWELVE_MONTHS = 'twelve_months',
  DDA = 'year_to_date'
}
